import React from 'react';
import moment from 'moment';
import nl2br from 'react-nl2br';
import { emojify } from 'react-emojione';

import Reply from 'components/RepliesList/Reply';
import { MailThreadShape } from 'entities';

const MailThread = props => {
  const { mailThread } = props;

  return (
    <Reply key={mailThread.id}
                isUnread={!mailThread.latestMessage.read}
                   since={moment(mailThread.latestMessage.createdAt).fromNow()}
            avatarLetter={mailThread.participant[0]}
          avatarImageUrl={mailThread.avatar.url}
              authorName={mailThread.participant}
                      to={`/messages/threads/${mailThread.id}`}>

      {nl2br(emojify(mailThread.latestMessage.text, {output: 'unicode'}))}

    </Reply>
  );
};

MailThread.propTypes = {
  mailThread: MailThreadShape
};

export default MailThread;



/** WEBPACK FOOTER **
 ** ./src/members/Main/Mail/MailThreadsList/MailThread/index.js
 **/